// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"96a0a527","306":"bfe216f1","337":"4bb28a58","359":"04ebee3a","488":"3bd8912d","500":"e165b0f3","512":"c8b06add","738":"cb17457b"}[chunkId] + ".chunk.js";
};